import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';
import { AsyncLocalStorageModule } from 'angular-async-local-storage';
import { routing, appRoutingProviders } from './app.routing';
import { AppComponent } from './app.component';
import { ModalModule } from 'ngx-bootstrap';
import { ButtonsModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { TooltipModule } from 'ngx-bootstrap';
import { LoadingModule } from 'ngx-loading';
import { BsDropdownModule } from 'ngx-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HttpClientModule } from '@angular/common/http';
import { TagsInputModule } from 'ngx-tags-input/dist';
import { RlTagInputModule } from 'angular2-tag-input';
import { RecaptchaModule, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { UiSwitchModule } from 'ngx-toggle-switch';
//import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';

import { BancoAddComponent } from './components/cobros/banco-add/banco-add.component';
import { BancoEditComponent } from './components/cobros/banco-edit/banco-edit.component';
import { BancoListComponent } from './components/cobros/banco-list/banco-list.component';
import { CobroListComponent } from './components/cobros/cobro-list/cobro-list.component';
import { CobroAddComponent } from './components/cobros/cobro-add/cobro-add.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from  './guards/auth.guard';
import { PermisoGuard } from  './guards/permiso.guard';
import { LockedLoginComponent } from './locked-login/locked-login.component';
import { SessionService } from './services/session.service';
import { UtilsService } from './services/utils.service';
import { CbtContadorService } from './services/cbt-contador.service';
import { FormaPagoAddComponent } from './components/cobros/forma-pago-add/forma-pago-add.component';
import { FormaPagoListComponent } from './components/cobros/forma-pago-list/forma-pago-list.component';
import { FormaPagoEditComponent } from './components/cobros/forma-pago-edit/forma-pago-edit.component';
import { ArqueoCajaAddComponent } from './components/cobros/arqueo-caja-add/arqueo-caja-add.component';
import { DesktopComponent } from './components/desktop/desktop/desktop.component';
import { LoginPrincipalComponent } from './components/login/login-principal/login-principal.component';
import { NewLoginComponent } from './components/login/new-login/new-login.component';
import { NewRegistroComponent } from './components/login/new-registro/new-registro.component';
import { LandingPageLoginComponent } from './components/login/landing-page-login/landing-page-login.component';
import { ComprasVsVentasComponent } from './components/charts/compras-vs-ventas/compras-vs-ventas.component';
// import { ProductosTopVendidosComponent } from './components/charts/productos-top-vendidos/productos-top-vendidos.component';
import { ClientesMasVentasComponent } from './components/charts/clientes-mas-ventas/clientes-mas-ventas.component';
import { ProveedoresMasComprasComponent } from './components/charts/proveedores-mas-compras/proveedores-mas-compras.component';
import { SucursalMasVentasComponent } from './components/charts/sucursal-mas-ventas/sucursal-mas-ventas.component';
// import { ClienteFrmAddComponent } from './forms/cliente-frm-add/cliente-frm-add.component';
// import { ClienteBasicFrmAddComponent } from './forms/cliente-basic-frm-add/cliente-basic-frm-add.component';
// import { ProductoFrmAddComponent } from './forms/producto-frm-add/producto-frm-add.component';
// import { ProveedorFrmAddComponent } from './forms/proveedor-frm-add/proveedor-frm-add.component';
import { RegistroComponent } from './components/login/registro/registro.component';
import { MenuComponent } from './components/desktop/menu/menu.component';
import { SubmenuComponent } from './components/desktop/submenu/submenu.component';
import { CobroGrupoComponent } from './components/cobros/cobro-grupo/cobro-grupo.component';
import { PipesModule } from './pipes/pipes.module';
import { ControlsModule } from './controls/controls.module';
// import { LayoutsModule } from './layouts/layouts.module';
import { ModalsModule } from './components/modals/modals.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { FixedPluginComponent } from './layouts/fixedplugin/fixedplugin.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';




import { ProductoModalComponent } from './components/modals/producto-modal/producto-modal.component';
import { ServicioModalComponent } from './components/modals/servicio-modal/servicio-modal.component';
import { ProveedorModalComponent } from './components/modals/proveedor-modal/proveedor-modal.component';
import { BlockModalComponent } from './components/modals/block-modal/block-modal.component';
import { ClienteModalComponent } from './components/modals/cliente-modal/cliente-modal.component';
import { ClienteProformaModalComponent } from './components/modals/cliente-proforma-modal/cliente-proforma-modal.component';
import { ProductoPrecioModalComponent } from './components/modals/producto-precio-modal/producto-precio-modal.component';
import { VentaModalComponent } from './components/modals/venta-modal/venta-modal.component';
import { VentaFilterModalComponent } from './components/modals/venta-filter-modal/venta-filter-modal.component';
import { CompraModalComponent } from './components/modals/compra-modal/compra-modal.component';
import { CompraFilterModalComponent } from './components/modals/compra-filter-modal/compra-filter-modal.component';
import { VentaListModalComponent } from './components/modals/venta-list-modal/venta-list-modal.component';
import { RetencionModalComponent } from './components/modals/retencion-modal/retencion-modal.component';
import { RetencionCompraModalComponent } from './components/modals/retencion-compra-modal/retencion-compra-modal.component';
import { CompraListModalComponent } from './components/modals/compra-list-modal/compra-list-modal.component';
import { PermisoModalComponent } from './components/modals/permiso-modal/permiso-modal.component';
import { ImageModalComponent } from './components/modals/image-modal/image-modal.component';
import { AperturaCajaModalComponent } from './components/modals/apertura-caja-modal/apertura-caja-modal.component';
import { CierreCajaModalComponent } from './components/modals/cierre-caja-modal/cierre-caja-modal.component';
import { PrecioAdicionalModalComponent } from './components/modals/precio-adicional-modal/precio-adicional-modal.component';
import { ReposicionCajaModalComponent } from './components/modals/reposicion-caja-modal/reposicion-caja-modal.component';
import { UsuarioModalComponent } from './components/modals/usuario-modal/usuario-modal.component';
import { CajaModalComponent } from './components/modals/caja-modal/caja-modal.component';
import { ReporteModalComponent } from './components/modals/reporte-modal/reporte-modal.component';
import { FacturaModalComponent } from './components/modals/factura-modal/factura-modal.component';
import { ProformaModalComponent } from './components/modals/proforma-modal/proforma-modal.component';
import { GuiaremisionModalComponent } from './components/modals/guiaremision-modal/guiaremision-modal.component';
import { AjusteInventarioModalComponent } from './components/modals/ajuste-inventario-modal/ajuste-inventario-modal.component';
import { ReenviarCorreoComponent } from './components/modals/reenviar-correo/reenviar-correo.component';
import { TransferenciasModalComponent } from './components/modals/transferencias-modal/transferencias-modal.component';
import { TransferenciasListModalComponent } from './components/modals/transferencias-list-modal/transferencias-list-modal.component';
import { NotacreditoModalComponent } from './components/modals/notacredito-modal/notacredito-modal.component';
import { NotacreditoCompraModalComponent } from './components/modals/nota-credito-compra-modal/notacredito-compra-modal.component';
import { NotadebitoModalComponent } from './components/modals/notadebito-modal/notadebito-modal.component';
import { ConfirmacionAnulacionModalComponent } from './components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { EditarPrecioModalComponent } from './components/modals/editar-precio-modal/editar-precio-modal.component';
import { GastoModalComponent } from './components/modals/gasto-modal/gasto-modal.component';
import { PreciosModalComponent } from './components/modals/precios-modal/precios-modal.component';
import { PlanAcumulativoModalComponent } from './components/modals/plan-acumulativo-modal/plan-acumulativo-modal.component';
import { EmitirRetencionCompraModalComponent } from './components/modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
import { EmitirGuiaremisionVentaModalComponent } from './components/modals/emitir-guiaremision-venta-modal/emitir-guiaremision-venta-modal.component';
import { RetencionRentaModalComponent } from './components/modals/retencion-renta-modal/retencion-renta-modal.component';
import { LoteModalComponent } from './components/modals/lote-modal/lote-modal.component';
import { ComprasModule } from './components/compras/compras.module';
import { VentasModule } from './components/ventas/ventas.module';
import { LectorBarraModalComponent } from './components/modals/lector-barra-modal/lector-barra-modal.component';
import { CustomFormModule } from './forms/custom-form.module';
import { CruceNotaCreditoComponent } from './components/cobros/cruce-nota-credito/cruce-nota-credito.component';
import { TransportistaModalComponent } from './components/modals/transportista-modal/transportista-modal.component';
import { CompraNotaModalComponent } from './components/modals/compra-nota-modal/compra-nota-modal.component';
import { VentaNotaModalComponent } from './components/modals/venta-nota-modal/venta-nota-modal.component';
import { VentasnetasxanioComponent } from './components/charts/ventasnetasxanio/ventasnetasxanio.component';
import { OrdenCompraModalComponent } from './components/modals/orden-compra-modal/orden-compra-modal.component';
import { OrdenCompraAddModalComponent } from './components/modals/orden-compra-add-modal/orden-compra-add-modal.component';
import { PlanCuentasAddModalComponent } from './components/modals/plan-cuentas-add-modal/plan-cuentas-add-modal.component';
import { PlanCuentasEditModalComponent } from './components/modals/plan-cuentas-edit-modal/plan-cuentas-edit-modal.component';

import { PeriodoAddModalComponent } from './components/modals/periodo-add-modal/periodo-add-modal.component';
import { PeriodoEditModalComponent } from './components/modals/periodo-edit-modal/periodo-edit-modal.component';
import { SalaMesaModalComponent } from './components/modals/sala-mesa-modal/sala-mesa-modal.component';
import { FacturarPedidoModalComponent } from './components/modals/facturar-pedido-modal/facturar-pedido-modal.component';
import { CuentaContableModalComponent } from './components/modals/cuenta-contable-modal/cuenta-contable-modal.component';
import { TipoActivoFijoModalComponent } from './components/modals/tipo-activo-fijo-modal/tipo-activo-fijo-modal.component';
import { AsientoContableDetalleModalComponent } from './components/modals/asiento-contable-modal/asiento-contable-detalle-modal.component';
import { AsientoContableEditModalComponent } from './components/modals/asiento-contable-edit-modal/asiento-contable-edit-modal.component';
import { AsientoContableModalComponent } from './components/modals/asiento-contable-modal/asiento-contable-modal.component';
import { NivelHotelEditModalComponent } from './components/modals/nivel-hotel-edit-modal/nivel-hotel-edit-modal.component';
import { TipoHabitacionHotelEditModalComponent } from './components/modals/tipo-habitacion-hotel-edit-modal/tipo-habitacion-hotel-edit-modal.component';
import { HabitacionAddModalComponent } from './components/modals/habitacion-add-modal/habitacion-add-modal.component';
import { HabitacionEditModalComponent } from './components/modals/habitacion-edit-modal/habitacion-edit-modal.component';

import { ActivoFijoModalComponent } from './components/modals/activo-fijo-modal/activo-fijo-modal.component';
// import { DecimalNumberDirective } from './config/decimal-number.directive';

import { PedidosSinSalaComponent } from './components/modals/pedidos-sin-sala/pedidos-sin-sala.component';
import { IceModalComponent } from './components/modals/ice-modal/ice-modal.component';
import { CuentaContableAsientoModalComponent } from './components/modals/cuenta-contable-asiento-modal/cuenta-contable-asiento-modal.component';
import { CuentaContableBancoModalComponent } from './components/modals/cuenta-contable-banco-modal/cuenta-contable-banco-modal.component';
import { CuentaBancariaModalComponent } from './components/modals/cuenta-bancaria-modal/cuenta-bancaria-modal.component';
import { MovimientoBancarioModalComponent } from './components/modals/movimiento-bancario-modal/movimiento-bancario-modal.component';
import { ConciliacionModalComponent } from './components/modals/conciliacion-modal/conciliacion-modal.component';
import { PrecioEditModalComponent } from './components/modals/precio-edit-modal/precio-edit-modal.component';
import { SerieIngresoModalComponent } from './components/modals/serie-ingreso-modal/serie-ingreso-modal.component';
import { SerieEgresoModalComponent } from './components/modals/serie-egreso-modal/serie-egreso-modal.component';
import { ProductosMasVendidosComponent } from './components/charts/productos-mas-vendidos/productos-mas-vendidos.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SerieDetalleModalComponent } from './components/modals/serie-detalle-modal/serie-detalle-modal.component';
import { TextMaskModule } from 'angular2-text-mask';



@NgModule({
  declarations: [
    AppComponent,
    BancoAddComponent,
    BancoEditComponent,
    BancoListComponent,
    CobroListComponent,
    CobroAddComponent,
    LoginComponent,
    LockedLoginComponent,
    FormaPagoAddComponent,
    FormaPagoListComponent,
    FormaPagoEditComponent,
    ArqueoCajaAddComponent,
    DesktopComponent,
    LoginPrincipalComponent,
    NewLoginComponent,
    NewRegistroComponent,
    LandingPageLoginComponent,
    ComprasVsVentasComponent,
    ProductosMasVendidosComponent,
    ClientesMasVentasComponent,
    ProveedoresMasComprasComponent,
    SucursalMasVentasComponent,
    // ClienteFrmAddComponent,
    // ClienteBasicFrmAddComponent,
    // ProductoFrmAddComponent,
    // ProveedorFrmAddComponent,
    RegistroComponent,
    MenuComponent,
    SubmenuComponent,
    CobroGrupoComponent,
    AdminLayoutComponent,
    FixedPluginComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    
    //Modals
    ProductoModalComponent,
    ServicioModalComponent,
    ProveedorModalComponent,
    BlockModalComponent,
    ClienteModalComponent,
    ClienteProformaModalComponent,
    ProductoPrecioModalComponent,
    VentaModalComponent,
    VentaFilterModalComponent,
    CompraModalComponent,
    CompraFilterModalComponent,
    VentaListModalComponent,
    RetencionModalComponent,
    RetencionCompraModalComponent,
    CompraListModalComponent,
    PermisoModalComponent,
    ImageModalComponent,
    AperturaCajaModalComponent,
    CierreCajaModalComponent,
    PrecioAdicionalModalComponent,
    ReposicionCajaModalComponent,
    UsuarioModalComponent,
    CajaModalComponent,
    ReporteModalComponent,
    FacturaModalComponent,
    ProformaModalComponent,
    GuiaremisionModalComponent,
    AjusteInventarioModalComponent,
    ReenviarCorreoComponent,
    TransferenciasModalComponent,
    TransferenciasListModalComponent,
    NotacreditoModalComponent,
    NotacreditoCompraModalComponent,
    NotadebitoModalComponent,
    ConfirmacionAnulacionModalComponent,
    EditarPrecioModalComponent,
    GastoModalComponent,
    PreciosModalComponent,
    OrdenCompraModalComponent,
    OrdenCompraAddModalComponent,
    PlanAcumulativoModalComponent,
    EmitirRetencionCompraModalComponent,
    EmitirGuiaremisionVentaModalComponent,
    RetencionRentaModalComponent,
    LoteModalComponent,
    LectorBarraModalComponent,
    CruceNotaCreditoComponent,
    TransportistaModalComponent,
    CompraNotaModalComponent,
    VentaNotaModalComponent,
    VentasnetasxanioComponent,
    PeriodoAddModalComponent,
    PeriodoEditModalComponent,
    SalaMesaModalComponent,
    FacturarPedidoModalComponent,
    PlanCuentasAddModalComponent,
    PlanCuentasEditModalComponent,
    CuentaContableModalComponent,
    TipoActivoFijoModalComponent,
    AsientoContableDetalleModalComponent,
    AsientoContableEditModalComponent,
    AsientoContableModalComponent,
    NivelHotelEditModalComponent,
    TipoHabitacionHotelEditModalComponent,
    HabitacionAddModalComponent,
    HabitacionEditModalComponent,
   
    ActivoFijoModalComponent,
    // DecimalNumberDirective,
    PedidosSinSalaComponent,
    IceModalComponent,
    CuentaContableAsientoModalComponent,
    CuentaContableBancoModalComponent,
    CuentaBancariaModalComponent,
    MovimientoBancarioModalComponent,
    ConciliacionModalComponent,
    PrecioEditModalComponent,
    SerieIngresoModalComponent,
    SerieEgresoModalComponent,
    SerieDetalleModalComponent
    
  ],
  entryComponents: [
    // ClienteBasicFrmAddComponent,
    CobroGrupoComponent,
    ClienteModalComponent,
    ClienteProformaModalComponent,
    ProductoPrecioModalComponent,
    ProveedorModalComponent,
    ProductoModalComponent,
    ServicioModalComponent,
    UsuarioModalComponent,
    CajaModalComponent,
    ReporteModalComponent,
    VentaModalComponent,
    VentaFilterModalComponent,
    CompraModalComponent,
    CompraFilterModalComponent,
    VentaListModalComponent,
    RetencionModalComponent,
    RetencionCompraModalComponent,
    CompraListModalComponent,
    PermisoModalComponent,
    ImageModalComponent,
    AperturaCajaModalComponent,
    CierreCajaModalComponent,
    PrecioAdicionalModalComponent,
    EditarPrecioModalComponent,
    ReposicionCajaModalComponent,
    FacturaModalComponent,
    ProformaModalComponent,
    GuiaremisionModalComponent,
    LoteModalComponent,
    AjusteInventarioModalComponent,
    ReenviarCorreoComponent, 
    TransferenciasModalComponent,
    TransferenciasListModalComponent,
    NotacreditoModalComponent,
    NotacreditoCompraModalComponent,
    NotadebitoModalComponent,
    ConfirmacionAnulacionModalComponent,
    GastoModalComponent,
    OrdenCompraModalComponent,
    OrdenCompraAddModalComponent,
    PreciosModalComponent,
    PlanAcumulativoModalComponent,
    EmitirRetencionCompraModalComponent,
    EmitirGuiaremisionVentaModalComponent,
    RetencionRentaModalComponent,
    TransportistaModalComponent,
    CompraNotaModalComponent,
    LectorBarraModalComponent,
    VentaNotaModalComponent,
    PlanCuentasAddModalComponent,
    PlanCuentasEditModalComponent,
    PeriodoAddModalComponent,
    PeriodoEditModalComponent,
    SalaMesaModalComponent,
    FacturarPedidoModalComponent,
    PlanCuentasAddModalComponent,
    PlanCuentasEditModalComponent,
    CuentaContableModalComponent,
    TipoActivoFijoModalComponent,
    AsientoContableDetalleModalComponent,
    AsientoContableEditModalComponent,
    AsientoContableModalComponent,
    NivelHotelEditModalComponent,
    TipoHabitacionHotelEditModalComponent,
    HabitacionAddModalComponent,
    HabitacionEditModalComponent,
    ActivoFijoModalComponent,
    PedidosSinSalaComponent,
    IceModalComponent,
    CuentaContableAsientoModalComponent,
    CuentaContableBancoModalComponent,
    CuentaBancariaModalComponent,
    MovimientoBancarioModalComponent,
    ConciliacionModalComponent,
    PrecioEditModalComponent,
    SerieIngresoModalComponent,
    SerieEgresoModalComponent,
    ProductosMasVendidosComponent,
    SerieDetalleModalComponent
    
  ],
  imports: [
    ModalModule.forRoot(),
    ButtonsModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    TagsInputModule.forRoot(),
    //ToastModule.forRoot(),
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
    PipesModule,
    ComprasModule,
    VentasModule,
    ControlsModule,
    JsonpModule,
    AsyncLocalStorageModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NguiDatetimePickerModule,
    HttpClientModule,
    ImageCropperModule,
    RlTagInputModule,
    RecaptchaModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    TreeGridModule,
    UiSwitchModule,
    // LayoutsModule,
    ModalsModule,
    CustomFormModule,
    ComprasModule,
    VentasModule,
    NgMultiSelectDropDownModule.forRoot(),
    TextMaskModule,
    // DirectivesModule
  ],
  providers: [
    appRoutingProviders,
    AuthGuard,
    PermisoGuard,
    SessionService,
    UtilsService,
    CbtContadorService
    // { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LdjqtYZAAAAAAUefV4m0wfcqxgzvUVO0UpULPBF' },
  ],
  // exports:[
  //   // DecimalNumberDirective
  //   ProductosTopVendidosComponent,
  // ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/app.module.ts